import { normalizeQuery } from "./villus.mjs";
import { clone } from "lodash-es";
import { stripIgnoredCharacters } from "graphql";
const exclude = [
  // Skips all mutations
  /mutation/,
  /query Identity/,
  /PaymentMethods/,
  /Cart/i,
  /SelectedAddress/,
  /Order/i,
  /Customer/i,
  /Wishlist/i,
  /DeliveryDays/,
  /StockBackNotificationIds/
];
const skippedQueries = [
  /query CustomerOrderDetails/,
  /query CustomerOrders/,
  /query PendingOrdersCount/,
  /query GuestCartCrossSellProducts/,
  /query CustomerCartCrossSellProducts/
];
export function getOrderSource() {
  if (process.client && sessionStorage.getItem("orderSource")) {
    return process.client && sessionStorage.getItem("orderSource") || "";
  }
  return null;
}
export function varnishPlugin() {
  return function varnishPlugin2({ opContext, operation }) {
    const normalizedQuery = stripIgnoredCharacters(
      normalizeQuery(operation.query)?.replace(/\n|\r/g, "") || ""
    );
    if (operation.type === "query" && !skippedQueries.some((r) => r.test(normalizedQuery))) {
      const headers = clone(opContext.headers);
      const stockSource = headers.sourcecode ? headers.sourcecode : getOrderSource();
      if (!exclude.some((r) => r.test(normalizedQuery))) {
        delete headers.authorization;
      }
      opContext.method = "GET";
      opContext.url = opContext.url + `?query=${encodeURIComponent(
        normalizedQuery
      )}&variables=${encodeURIComponent(
        JSON.stringify(operation.variables)?.replace(/\n|\r/g, "")
      )}${stockSource ? "&source=" + stockSource : ""}`, opContext.headers = headers;
      opContext.body = void 0;
    }
  };
}
